import { AppKeys } from './const';
import { MessageType } from './model';
import { newMsg } from './utils';

export const msgOpJoinSpace = (val1: MessageType, val2: MessageType) =>
  newMsg(AppKeys.Op_Join_Space, [
    { tag: 'val1', value: val1 },
    { tag: 'val2', value: val2 },
  ]);

export const msgOpJoinBrakets = (val1: MessageType, val2: MessageType) =>
  newMsg(AppKeys.Op_Join_Brakets, [
    { tag: 'val1', value: val1 },
    { tag: 'val2', value: val2 },
  ]);
export const msgTo = (toVal: MessageType, valExtra?: MessageType) =>
  newMsg(AppKeys.Com_ToValue, [
    {
      tag: 'value',
      value: valExtra ? msgOpJoinBrakets(toVal, valExtra) : toVal,
    },
  ]);
export const msgFrom = (fromVal: MessageType, valExtra?: MessageType) =>
  newMsg(AppKeys.Com_FromValue, [
    {
      tag: 'value',
      value: valExtra ? msgOpJoinBrakets(fromVal, valExtra) : fromVal,
    },
  ]);
export const msgBy = (byVal: MessageType, valExtra?: MessageType) =>
  newMsg(AppKeys.Com_ByValue, [
    {
      tag: 'value',
      value: valExtra ? msgOpJoinBrakets(byVal, valExtra) : byVal,
    },
  ]);

export const msgNumDevice = (n: number) =>
  newMsg(AppKeys.Num_Device, [{ tag: 'count', value: n }]);

export const msgRetryBtn = newMsg(AppKeys.Btn_Retry);